/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refinepromptplaceholder2Inputs */

const en_refinepromptplaceholder2 = /** @type {(inputs: Refinepromptplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blur the background and brighten the colors…`)
};

const de_refinepromptplaceholder2 = /** @type {(inputs: Refinepromptplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintergrund unscharf machen und Farben aufhellen…`)
};

/**
* | output |
* | --- |
* | "Blur the background and brighten the colors…" |
*
* @param {Refinepromptplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refinepromptplaceholder2 = /** @type {((inputs?: Refinepromptplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refinepromptplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refinepromptplaceholder2(inputs)
	return de_refinepromptplaceholder2(inputs)
});
export { refinepromptplaceholder2 as "refinePromptPlaceholder" }